import React from 'react';
import '../css/emptyNotification.css';
import { EmptyNotificationIcon } from '../../../../../../asset-controller-mod/asset-serv/icons/iconExporter';

const EmptyNotification: React.FC = () => {
  return (
    <div className="scl--cms-components-emptyNotification">

      {/* ── Icon Container ── */}
      <div className="scl--cms-components-emptyNotification-iconWrapper">
        <EmptyNotificationIcon/>
      </div>

      {/* ── Text Block ── */}
      <div className="scl--cms-components-emptyNotification-textBlock">
        <span className="scl--cms-components-emptyNotification-title">
          No Notifications
        </span>
        <p className="scl--cms-components-emptyNotification-description">
          We'll let you know when there will be something to update you.
        </p>
      </div>

    </div>
  );
};

export default EmptyNotification;